// extracted by mini-css-extract-plugin
module.exports = {"vimeoBackground":"styles_vimeoBackground__ZpPQH","backgroundVideo":"styles_backgroundVideo__Ras6e","backgroundVideo__overflow":"styles_backgroundVideo__overflow__mdZJ3"};